{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Odstrániť integráciu Shopify",
        "MESSAGE": "Naozaj chcete odstrániť integráciu Shopify?"
      },
      "STORE_URL": {
        "TITLE": "Pripojiť obchod Shopify",
        "LABEL": "URL obchodu",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Zadajte URL vášho obchodu Shopify v tvare myshopify.com",
        "CANCEL": "Zrušiť",
        "SUBMIT": "Pripojiť obchod"
      },
      "ERROR": "Pri pripájaní k Shopify nastala chyba. Skúste to prosím znova. Ak problém pretrváva, kontaktujte podporu."
    },
    "HEADER": "Integrácie",
    "DESCRIPTION": "Kontaktné centrum sa integruje s mnohými nástrojmi a službami, ktoré zvyšujú efektivitu vášho tímu. Prezrite si zoznam nižšie a nastavte si obľúbené aplikácie.",
    "LEARN_MORE": "Zistiť viac o integráciách",
    "LOADING": "Načítavajú sa integrácie",
    "CAPTAIN": {
      "DISABLED": "Captain nie je vo vašom účte povolený.",
      "CLICK_HERE_TO_CONFIGURE": "Kliknite sem pre konfiguráciu",
      "LOADING_CONSOLE": "Načítava sa konzola Captain...",
      "FAILED_TO_LOAD_CONSOLE": "Nepodarilo sa načítať konzolu Captain. Obnovte stránku a skúste to znova."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Odoberané udalosti",
      "LEARN_MORE": "Zistiť viac o webhookoch",
      "FORM": {
        "CANCEL": "Zrušiť",
        "DESC": "Udalosti webhooku vám poskytujú informácie v reálnom čase o tom, čo sa deje vo vašom účte. Zadajte platnú URL adresu na nastavenie callbacku.",
        "SUBSCRIPTIONS": {
          "LABEL": "Udalosti",
          "EVENTS": {
            "CONVERSATION_CREATED": "Konverzácia vytvorená",
            "CONVERSATION_STATUS_CHANGED": "Stav konverzácie zmenený",
            "CONVERSATION_UPDATED": "Konverzácia aktualizovaná",
            "MESSAGE_CREATED": "Správa vytvorená",
            "MESSAGE_UPDATED": "Správa aktualizovaná",
            "WEBWIDGET_TRIGGERED": "Používateľ otvoril widget živého chatu",
            "CONTACT_CREATED": "Kontakt vytvorený",
            "CONTACT_UPDATED": "Kontakt aktualizovaný",
            "JARABOT_EVENT": "Interné udalosti",
            "INBOX_CREATED": "Schránka vytvorená"
          }
        },
        "END_POINT": {
          "LABEL": "URL webhooku",
          "PLACEHOLDER": "Príklad: {webhookExampleURL}",
          "ERROR": "Prosím zadajte platnú URL"
        },
        "EDIT_SUBMIT": "Aktualizovať webhook",
        "ADD_SUBMIT": "Vytvoriť webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Nastaviť",
      "HEADER": "Nastavenia webhooku",
      "HEADER_BTN_TXT": "Pridať nový webhook",
      "LOADING": "Načítavajú sa pripojené webhooky",
      "SEARCH_404": "Neexistujú žiadne položky, ktoré by zodpovedali tejto požiadavke",
      "SIDEBAR_TXT": "<p><b>Webhooky</b> </p> <p>Webhooky sú HTTP callbacky, ktoré možno definovať pre každý účet. Spúšťajú ich udalosti, napríklad vytvorenie správy. Pre tento účet môžete vytvoriť viac ako jeden webhook. <br /><br /> Ak chcete vytvoriť <b>webhook</b>, kliknite na tlačidlo <b>Pridať nový webhook</b>. Existujúci webhook môžete odstrániť kliknutím na tlačidlo Odstrániť.</p>",
      "LIST": {
        "404": "Pre tento účet nie sú nakonfigurované žiadne webhooky.",
        "TITLE": "Spravovať webhooky",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Endpoint webhooku",
          "ACTIONS": "Akcie"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Upraviť",
        "TITLE": "Upraviť webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfigurácia webhooku bola úspešne aktualizovaná",
          "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
        }
      },
      "ADD": {
        "CANCEL": "Zrušiť",
        "TITLE": "Pridať nový webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfigurácia webhooku bola úspešne pridaná",
          "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Vymazať",
        "API": {
          "SUCCESS_MESSAGE": "Webhook bol úspešne odstránený",
          "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
        },
        "CONFIRM": {
          "TITLE": "Potvrdiť vymazanie",
          "MESSAGE": "Naozaj chcete odstrániť webhook? ({webhookURL})",
          "YES": "Áno, vymazať ",
          "NO": "Nie, ponechať"
        }
      },
      "DISABLED_BADGE": "Vypnutý",
      "DISABLED_REASON": "Automaticky vypnutý po {count} zlyhaniach za sebou. Posledná chyba: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Zapnúť",
        "API": {
          "SUCCESS_MESSAGE": "Webhook bol úspešne zapnutý",
          "ERROR_MESSAGE": "Nepodarilo sa zapnúť webhook. Skúste to prosím neskôr."
        }
      }
    },
    "SLACK": {
      "DELETE": "Vymazať",
      "DELETE_CONFIRMATION": {
        "TITLE": "Odstrániť integráciu",
        "MESSAGE": "Naozaj chcete odstrániť integráciu? Stratíte tým prístup ku konverzáciám vo vašom pracovnom priestore Slack."
      },
      "HELP_TEXT": {
        "TITLE": "Using Slack Integration",
        "BODY": "Vďaka tejto integrácii sa všetky vaše prichádzajúce konverzácie budú synchronizovať do kanála ***{selectedChannelName}*** vo vašom pracovnom priestore Slack. Všetky konverzácie so zákazníkmi môžete spravovať priamo v kanáli a nezmeškáte žiadnu správu.\n\nHlavné funkcie integrácie:\n\n**Odpovedanie na konverzácie priamo zo Slacku:** Ak chcete odpovedať na konverzáciu v kanáli Slack ***{selectedChannelName}***, napíšte správu a odošlite ju ako vlákno. Odpoveď sa zákazníkovi odošle cez kontaktné centrum. Je to také jednoduché!\n\n **Súkromné poznámky:** Ak chcete namiesto odpovede vytvoriť súkromnú poznámku, začnite správu textom ***`note:`***. Správa tak zostane súkromná a zákazník ju neuvidí.\n\n**Priradenie profilu agenta:** Ak má osoba, ktorá odpovedala v Slacku, v kontaktnom centre profil agenta s rovnakým e-mailom, odpovede sa k tomuto profilu priradia automaticky. Ľahko tak zistíte, kto čo a kedy napísal. Ak odpovedajúci profil agenta nemá, zákazník uvidí odpovede od profilu bota.",
        "SELECTED": "vybrané"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Vyberte kanál",
        "UPDATE": "Aktualizovať",
        "BUTTON_TEXT": "Pripojiť kanál",
        "DESCRIPTION": "Váš pracovný priestor Slack je teraz prepojený s kontaktným centrom. Integrácia je však zatiaľ neaktívna. Ak chcete integráciu aktivovať a pripojiť kanál, kliknite na tlačidlo nižšie.\n\n**Poznámka:** Ak sa pokúšate pripojiť súkromný kanál, pred týmto krokom pridajte do kanála Slack našu aplikáciu.",
        "ATTENTION_REQUIRED": "Vyžaduje sa pozornosť",
        "EXPIRED": "Platnosť vašej integrácie Slack vypršala. Ak chcete naďalej dostávať správy v Slacku, odstráňte integráciu a znova pripojte svoj pracovný priestor."
      },
      "UPDATE_ERROR": "Pri aktualizácii integrácie nastala chyba. Skúste to prosím znova.",
      "UPDATE_SUCCESS": "Kanál bol úspešne pripojený",
      "FAILED_TO_FETCH_CHANNELS": "Pri načítavaní kanálov zo Slacku nastala chyba. Skúste to prosím znova."
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI asistent",
      "WITH_AI": " {option} s AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Návrh odpovede",
        "SUMMARIZE": "Zhrnúť",
        "REPHRASE": "Vylepšiť písanie",
        "FIX_SPELLING_GRAMMAR": "Opraviť pravopis a gramatiku",
        "SHORTEN": "Skrátiť",
        "EXPAND": "Rozšíriť",
        "MAKE_FRIENDLY": "Zmeniť tón správy na priateľský",
        "MAKE_FORMAL": "Použiť formálny tón",
        "SIMPLIFY": "Zjednodušiť",
        "TRANSLATE": "Preložiť",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Preložiť do väčšinového jazyka"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Koncept obsahu",
        "GENERATED_TITLE": "Vygenerovaný obsah",
        "AI_WRITING": "AI píše",
        "BUTTONS": {
          "APPLY": "Použiť tento návrh",
          "CANCEL": "Zrušiť"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrovať s OpenAI",
        "DESC": "Prineste pokročilé funkcie AI do vášho dashboardu pomocou modelov GPT od OpenAI. Na začiatok zadajte API kľúč z vášho účtu OpenAI.",
        "KEY_PLACEHOLDER": "Zadajte váš OpenAI API kľúč",
        "BUTTONS": {
          "NEED_HELP": "Potrebujete pomoc?",
          "DISMISS": "Zrušiť",
          "FINISH": "Dokončiť nastavenie"
        },
        "DISMISS_MESSAGE": "Integráciu OpenAI môžete nastaviť neskôr, kedykoľvek budete chcieť.",
        "SUCCESS_MESSAGE": "Integrácia OpenAI bola úspešne nastavená"
      },
      "TITLE": "Vylepšiť pomocou AI",
      "SUMMARY_TITLE": "Zhrnutie pomocou AI",
      "REPLY_TITLE": "Návrh odpovede pomocou AI",
      "SUBTITLE": "Vylepšená odpoveď bude vygenerovaná pomocou AI na základe vášho súčasného konceptu.",
      "TONE": {
        "TITLE": "Tón",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionálny",
          "FRIENDLY": "Priateľský"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generovať",
        "GENERATING": "Generujem...",
        "CANCEL": "Zrušiť"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Integrácia bola úspešne odstránená"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Pripojiť"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Aplikácie dashboardu",
      "HEADER_BTN_TXT": "Pridať novú dashboard aplikáciu",
      "SIDEBAR_TXT": "<p><b>Dashboard aplikácie</b></p><p>Dashboard aplikácie umožňujú organizáciám vložiť aplikáciu priamo do dashboardu a poskytnúť tak agentom zákazníckej podpory kontext. Aplikáciu môžete vytvoriť samostatne a vložiť ju do dashboardu, kde bude zobrazovať informácie o používateľovi, jeho objednávky alebo históriu platieb.</p><p>Keď vložíte svoju aplikáciu do dashboardu, dostane kontext konverzácie a kontaktu ako udalosť okna. Na svojej stránke implementujte listener pre udalosť message, aby ste kontext prijali.</p><p>Ak chcete pridať novú dashboard aplikáciu, kliknite na tlačidlo „Pridať novú dashboard aplikáciu“.</p>",
      "DESCRIPTION": "Aplikácie dashboardu umožňujú organizáciám vložiť aplikáciu do dashboardu a poskytnúť tak agentom zákazníckej podpory kontext. Aplikáciu môžete vytvoriť samostatne a vložiť ju tak, aby zobrazovala informácie o používateľovi, jeho objednávky alebo históriu platieb.",
      "LEARN_MORE": "Zistiť viac o aplikáciách dashboardu",
      "LIST": {
        "404": "V tomto účte zatiaľ nie sú nakonfigurované žiadne aplikácie dashboardu",
        "LOADING": "Načítavajú sa aplikácie dashboardu...",
        "TABLE_HEADER": {
          "NAME": "Meno",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Upraviť aplikáciu",
        "DELETE_TOOLTIP": "Odstrániť aplikáciu"
      },
      "FORM": {
        "TITLE_LABEL": "Meno",
        "TITLE_PLACEHOLDER": "Zadajte názov aplikácie dashboardu",
        "TITLE_ERROR": "Názov aplikácie dashboardu je povinný",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Zadajte URL endpointu, kde je vaša aplikácia hostovaná",
        "URL_ERROR": "Vyžaduje sa platná URL"
      },
      "CREATE": {
        "HEADER": "Pridať novú aplikáciu dashboardu",
        "FORM_SUBMIT": "Odoslať",
        "FORM_CANCEL": "Zrušiť",
        "API_SUCCESS": "Aplikácia dashboardu bola úspešne nakonfigurovaná",
        "API_ERROR": "Aplikáciu sa nepodarilo vytvoriť. Skúste to prosím neskôr."
      },
      "UPDATE": {
        "HEADER": "Upraviť aplikáciu dashboardu",
        "FORM_SUBMIT": "Aktualizovať",
        "FORM_CANCEL": "Zrušiť",
        "API_SUCCESS": "Aplikácia dashboardu bola úspešne aktualizovaná",
        "API_ERROR": "Aplikáciu sa nepodarilo aktualizovať. Skúste to prosím neskôr."
      },
      "DELETE": {
        "CONFIRM_YES": "Áno, odstrániť",
        "CONFIRM_NO": "Nie, ponechať",
        "TITLE": "Potvrdiť odstránenie",
        "MESSAGE": "Naozaj chcete odstrániť aplikáciu {appName}?",
        "API_SUCCESS": "Aplikácia dashboardu bola úspešne odstránená",
        "API_ERROR": "Aplikáciu sa nepodarilo odstrániť. Skúste to prosím neskôr."
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Vytvoriť/prepojiť úlohu Linear",
      "LOADING": "Načítavajú sa úlohy Linear...",
      "LOADING_ERROR": "Pri načítavaní úloh Linear nastala chyba. Skúste to prosím znova.",
      "CREATE": "Vytvoriť",
      "LINK": {
        "SEARCH": "Hľadať úlohy",
        "SELECT": "Vyberte úlohu",
        "TITLE": "Prepojiť",
        "EMPTY_LIST": "Nenašli sa žiadne úlohy Linear",
        "LOADING": "Načítava sa",
        "ERROR": "Pri načítavaní úloh Linear nastala chyba. Skúste to prosím znova.",
        "LINK_SUCCESS": "Úloha bola úspešne prepojená",
        "LINK_ERROR": "Pri prepájaní úlohy nastala chyba. Skúste to prosím znova.",
        "LINK_TITLE": "Konverzácia (#{conversationId}) s {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Vytvoriť/prepojiť úlohu Linear",
        "DESCRIPTION": "Vytvárajte úlohy Linear z konverzácií alebo prepojte existujúce úlohy pre jednoduché sledovanie.",
        "FORM": {
          "TITLE": {
            "LABEL": "Názov",
            "PLACEHOLDER": "Zadajte názov",
            "REQUIRED_ERROR": "Názov je povinný"
          },
          "DESCRIPTION": {
            "LABEL": "Popis",
            "PLACEHOLDER": "Zadajte popis"
          },
          "TEAM": {
            "LABEL": "Tím",
            "PLACEHOLDER": "Vybrať tím",
            "SEARCH": "Hľadať tím",
            "REQUIRED_ERROR": "Tím je povinný"
          },
          "ASSIGNEE": {
            "LABEL": "Pridelený agent",
            "PLACEHOLDER": "Vyberte riešiteľa",
            "SEARCH": "Hľadať riešiteľa"
          },
          "PRIORITY": {
            "LABEL": "Priorita",
            "PLACEHOLDER": "Vyberte prioritu",
            "SEARCH": "Hľadať prioritu"
          },
          "LABEL": {
            "LABEL": "Štítok",
            "PLACEHOLDER": "Vyberte štítok",
            "SEARCH": "Hľadať štítok"
          },
          "STATUS": {
            "LABEL": "Stav",
            "PLACEHOLDER": "Vyberte stav",
            "SEARCH": "Hľadať stav"
          },
          "PROJECT": {
            "LABEL": "Projekt",
            "PLACEHOLDER": "Vyberte projekt",
            "SEARCH": "Hľadať projekt"
          }
        },
        "CREATE": "Vytvoriť",
        "CANCEL": "Zrušiť",
        "CREATE_SUCCESS": "Úloha bola úspešne vytvorená",
        "CREATE_ERROR": "Pri vytváraní úlohy nastala chyba. Skúste to prosím znova.",
        "LOADING_TEAM_ERROR": "Pri načítavaní tímov nastala chyba. Skúste to prosím znova.",
        "LOADING_TEAM_ENTITIES_ERROR": "Pri načítavaní údajov tímu nastala chyba. Skúste to prosím znova."
      },
      "ISSUE": {
        "STATUS": "Stav",
        "PRIORITY": "Priorita",
        "ASSIGNEE": "Pridelený agent",
        "LABELS": "Štítky",
        "CREATED_AT": "Vytvorené {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Zrušiť prepojenie",
        "SUCCESS": "Prepojenie úlohy bolo úspešne zrušené",
        "ERROR": "Pri rušení prepojenia úlohy nastala chyba. Skúste to prosím znova."
      },
      "DELETE": {
        "TITLE": "Naozaj chcete odstrániť integráciu?",
        "MESSAGE": "Naozaj chcete odstrániť integráciu?",
        "CONFIRM": "Áno, odstrániť",
        "CANCEL": "Zrušiť"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Zistiť viac",
    "COPILOT": {
      "SEND_MESSAGE": "Poslať správu...",
      "LOADER": "Captain premýšľa",
      "YOU": "Vy",
      "USE": "Použiť toto",
      "RESET": "Obnoviť",
      "SELECT_ASSISTANT": "Vybrať asistenta",
      "EMPTY_MESSAGE": "Pri generovaní odpovede došlo k chybe. Skúste to prosím znova."
    },
    "PAYWALL": {
      "TITLE": "Inovujte, aby ste mohli používať Captain AI",
      "AVAILABLE_ON": "Captain nie je dostupný v bezplatnom pláne.",
      "UPGRADE_PROMPT": "Inovujte svoj plán a získajte prístup k asistentom, nástroju Copilot a ďalším funkciám.",
      "UPGRADE_NOW": "Inovovať teraz",
      "CANCEL_ANYTIME": "Svoj plán môžete kedykoľvek zmeniť alebo zrušiť"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Funkcia Captain AI je dostupná iba v platenom pláne.",
      "UPGRADE_PROMPT": "Inovujte svoj plán a získajte prístup k asistentom, nástroju Copilot a ďalším funkciám.",
      "ASK_ADMIN": "Ohľadom inovácie sa prosím obráťte na svojho administrátora."
    },
    "BANNER": {
      "RESPONSES": "Využili ste už viac ako 80 % svojho limitu odpovedí. Ak chcete pokračovať v používaní Captain AI, inovujte svoj plán.",
      "DOCUMENTS": "Dosiahli ste limit dokumentov. Ak chcete pokračovať v používaní Captain AI, inovujte svoj plán."
    },
    "FORM": {
      "CANCEL": "Zrušiť",
      "CREATE": "Vytvoriť",
      "EDIT": "Aktualizovať"
    },
    "ASSISTANTS": {
      "HEADER": "Asistenti",
      "ADD_NEW": "Vytvoriť nového asistenta",
      "DELETE": {
        "TITLE": "Naozaj chcete odstrániť asistenta?",
        "DESCRIPTION": "Toto je trvalá akcia. Odstránením tohto asistenta ho odstránite zo všetkých pripojených schránok a natrvalo vymažete všetky vygenerované znalosti.",
        "CONFIRM": "Áno, vymazať",
        "SUCCESS_MESSAGE": "Asistent bol úspešne odstránený",
        "ERROR_MESSAGE": "Pri odstraňovaní asistenta došlo k chybe, skúste to prosím znova."
      },
      "FORM_DESCRIPTION": "Vyplňte nasledujúce údaje: pomenujte svojho asistenta, opíšte jeho účel a uveďte produkt, ktorý bude podporovať.",
      "CREATE": {
        "TITLE": "Vytvoriť asistenta",
        "SUCCESS_MESSAGE": "Asistent bol úspešne vytvorený",
        "ERROR_MESSAGE": "Pri vytváraní asistenta došlo k chybe, skúste to prosím znova."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Meno asistenta",
          "PLACEHOLDER": "Zadajte meno asistenta",
          "ERROR": "Meno asistenta je povinné"
        },
        "DESCRIPTION": {
          "LABEL": "Popis asistenta",
          "PLACEHOLDER": "Opíšte, ako a kde sa bude tento asistent používať",
          "ERROR": "Popis je povinný"
        },
        "PRODUCT_NAME": {
          "LABEL": "Názov produktu",
          "PLACEHOLDER": "Zadajte názov produktu, pre ktorý je tento asistent určený",
          "ERROR": "Názov produktu je povinný"
        },
        "FEATURES": {
          "TITLE": "Funkcie",
          "ALLOW_CONVERSATION_FAQS": "Generovať časté otázky z vyriešených konverzácií",
          "ALLOW_MEMORIES": "Zaznamenávať kľúčové detaily z komunikácie so zákazníkmi vo forme spomienok."
        }
      },
      "EDIT": {
        "TITLE": "Aktualizovať asistenta",
        "SUCCESS_MESSAGE": "Asistent bol úspešne aktualizovaný",
        "ERROR_MESSAGE": "Pri aktualizácii asistenta došlo k chybe, skúste to prosím znova."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Upraviť asistenta",
        "DELETE_ASSISTANT": "Odstrániť asistenta",
        "VIEW_CONNECTED_INBOXES": "Zobraziť pripojené schránky"
      },
      "EMPTY_STATE": {
        "TITLE": "Nie sú k dispozícii žiadni asistenti",
        "SUBTITLE": "Vytvorte asistenta, ktorý bude poskytovať rýchle a presné odpovede vašim používateľom. Dokáže sa učiť z vašich článkov pomocníka a predchádzajúcich konverzácií.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain asistent",
          "NOTE": "Captain Assistant komunikuje priamo so zákazníkmi, učí sa z vašich dokumentov pomocníka a predchádzajúcich konverzácií a poskytuje okamžité a presné odpovede. Rieši počiatočné otázky a poskytuje rýchle vyriešenie skôr, ako  ho v prípade potreby odovzdá agentovi."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Dokumenty",
      "ADD_NEW": "Vytvoriť nový dokument",
      "RELATED_RESPONSES": {
        "TITLE": "Súvisiace časté otázky",
        "DESCRIPTION": "Tieto časté otázky sú generované priamo z dokumentu."
      },
      "FORM_DESCRIPTION": "Zadajte URL dokumentu, aby ste ho pridali ako zdroj znalostí, a vyberte asistenta, ku ktorému ho chcete priradiť.",
      "CREATE": {
        "TITLE": "Pridať dokument",
        "SUCCESS_MESSAGE": "Dokument bol úspešne vytvorený",
        "ERROR_MESSAGE": "Pri vytváraní dokumentu došlo k chybe, skúste to prosím znova."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Zadajte URL dokumentu",
          "ERROR": "Zadajte prosím platnú URL dokumentu"
        },
        "ASSISTANT": {
          "LABEL": "Asistent",
          "PLACEHOLDER": "Vyberte asistenta",
          "ERROR": "Asistent je povinný"
        }
      },
      "DELETE": {
        "TITLE": "Naozaj chcete odstrániť dokument?",
        "DESCRIPTION": "Toto je trvalá akcia. Odstránením tohto dokumentu natrvalo vymažete všetky vygenerované znalosti.",
        "CONFIRM": "Áno, vymazať",
        "SUCCESS_MESSAGE": "Dokument bol úspešne odstránený",
        "ERROR_MESSAGE": "Pri odstraňovaní dokumentu došlo k chybe, skúste to prosím znova."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Zobraziť súvisiace odpovede",
        "DELETE_DOCUMENT": "Odstrániť dokument"
      },
      "EMPTY_STATE": {
        "TITLE": "Nie sú k dispozícii žiadne dokumenty",
        "SUBTITLE": "Dokumenty používa váš asistent na generovanie častých otázok. Dokumenty môžete importovať, aby ste asistentovi poskytli kontext.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain dokument",
          "NOTE": "Dokument v Captain slúži ako zdroj znalostí pre asistenta. Pripojením centra pomoci alebo návodov dokáže Captain analyzovať obsah a poskytovať presné odpovede na otázky zákazníkov."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "Časté otázky",
      "ADD_NEW": "Vytvoriť novú otázku",
      "DOCUMENTABLE": {
        "CONVERSATION": "Konverzácia #{id}"
      },
      "SELECTED": "{count} vybraných",
      "BULK_APPROVE_BUTTON": "Schváliť",
      "BULK_DELETE_BUTTON": "Vymazať",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "Otázky boli úspešne schválené",
        "ERROR_MESSAGE": "Pri schvaľovaní otázok nastala chyba, skúste to prosím znova."
      },
      "BULK_DELETE": {
        "TITLE": "Vymazať otázky?",
        "DESCRIPTION": "Naozaj chcete vymazať vybrané otázky? Túto akciu nie je možné vrátiť späť.",
        "CONFIRM": "Áno, vymazať všetky",
        "SUCCESS_MESSAGE": "Otázky boli úspešne vymazané",
        "ERROR_MESSAGE": "Pri vymazávaní otázok nastala chyba, skúste to prosím znova."
      },
      "DELETE": {
        "TITLE": "Naozaj chcete vymazať otázku?",
        "DESCRIPTION": "",
        "CONFIRM": "Áno, vymazať",
        "SUCCESS_MESSAGE": "Otázka bola úspešne vymazaná",
        "ERROR_MESSAGE": "Pri vymazávaní otázky nastala chyba, skúste to prosím znova."
      },
      "FILTER": {
        "ASSISTANT": "Asistent: {selected}",
        "STATUS": "Stav: {selected}",
        "ALL_ASSISTANTS": "Všetko"
      },
      "STATUS": {
        "TITLE": "Stav",
        "PENDING": "Čaká sa na",
        "APPROVED": "Schválené",
        "ALL": "Všetko"
      },
      "FORM_DESCRIPTION": "Pridajte otázku a k nej zodpovedajúcu odpoveď do znalostnej bázy a vyberte asistenta, ku ktorému má byť priradená.",
      "CREATE": {
        "TITLE": "Pridať otázku",
        "SUCCESS_MESSAGE": "Odpoveď bola úspešne pridaná.",
        "ERROR_MESSAGE": "Pri pridávaní odpovede nastala chyba. Skúste to prosím znova."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Otázka",
          "PLACEHOLDER": "Sem zadajte otázku",
          "ERROR": "Zadajte prosím platnú otázku."
        },
        "ANSWER": {
          "LABEL": "Odpoveď",
          "PLACEHOLDER": "Sem zadajte odpoveď",
          "ERROR": "Zadajte prosím platnú odpoveď."
        },
        "ASSISTANT": {
          "LABEL": "Asistent",
          "PLACEHOLDER": "Vyberte asistenta",
          "ERROR": "Vyberte prosím asistenta."
        }
      },
      "EDIT": {
        "TITLE": "Upraviť otázku",
        "SUCCESS_MESSAGE": "Otázka bola úspešne upravená",
        "ERROR_MESSAGE": "Pri úprave otázky nastala chyba, skúste to prosím znova",
        "APPROVE_SUCCESS_MESSAGE": "Otázka bola označená ako schválená"
      },
      "OPTIONS": {
        "APPROVE": "Označiť ako schválené",
        "EDIT_RESPONSE": "Upraviť otázku",
        "DELETE_RESPONSE": "Vymazať otázku"
      },
      "EMPTY_STATE": {
        "TITLE": "Nenašli sa žiadne otázky",
        "SUBTITLE": "Časté otázky pomáhajú vášmu asistentovi poskytovať rýchle a presné odpovede na otázky vašich zákazníkov. Môžu byť vygenerované automaticky z vášho obsahu alebo pridané manuálne.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain rozpoznáva bežné otázky zákazníkov — či už chýbajú vo vašej znalostnej báze, alebo sú kladené často — a generuje relevantné otázky na zlepšenie podpory. Každý návrh môžete skontrolovať a rozhodnúť, či ho schválite, alebo zamietnete."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Pripojené schránky",
      "ADD_NEW": "Pripojiť novú schránku",
      "OPTIONS": {
        "DISCONNECT": "Odpojiť"
      },
      "DELETE": {
        "TITLE": "Naozaj chcete odpojiť schránku?",
        "DESCRIPTION": "",
        "CONFIRM": "Áno, vymazať",
        "SUCCESS_MESSAGE": "Schránka bola úspešne odpojená.",
        "ERROR_MESSAGE": "Pri odpájaní schránky nastala chyba, skúste to prosím znova."
      },
      "FORM_DESCRIPTION": "Vyberte schránku, ktorú chcete pripojiť k asistentovi.",
      "CREATE": {
        "TITLE": "Pripojiť schránku",
        "SUCCESS_MESSAGE": "Schránka bola úspešne pripojená.",
        "ERROR_MESSAGE": "Pri pripájaní schránky nastala chyba. Skúste to prosím znova."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Schránka",
          "PLACEHOLDER": "Vyberte schránku, v ktorej chcete asistenta nasadiť.",
          "ERROR": "Výber schránky je povinný."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Žiadne pripojené schránky",
        "SUBTITLE": "Pripojenie schránky umožňuje asistentovi vybaviť úvodné otázky vašich zákazníkov predtým, ako ich odovzdá vám."
      }
    }
  }
}
